<template>
  <v-container :fluid="true" class="page_container">
    <div class="promo__title">
      <div class="d-flex" v-if="!search_panel && !filter_panel && $vuetify.display.width < 769 || $vuetify.display.width >= 769">
        <span class="promo__title--text">
          Промокоды <span v-if="!search_panel && !filter_panel && $vuetify.display.width < 960 || $vuetify.display.width >= 960"> и акции</span>
        </span>
        <v-chip-group
            v-if="$vuetify.display.width >= 1280"
            v-model="promo_selection"
            class="chip__container"
            mandatory
            @click="changePromoType(promo_selection)"
        >
          <v-chip>НОВЫЕ</v-chip>
          <v-chip>МОИ</v-chip>
        </v-chip-group>
      </div>
      <v-row no-gutters align="start" justify="end">
        <div v-if="filter_panel && !search_panel && promo_selection === 1" class="search__field">
          <v-select
              class="search__field_input"
              ref="filter-field-input"
              color="#3254B9"
              base-color="#313743"
              variant="outlined"
              item-title="text"
              item-value="value"
              no-data-text="Нет подходящих данных"
              :items="selectors.is_actual"
              v-model="filters.is_actual"
              :loading="isLoading"
              :disabled="isLoading"
              @update:model-value="clickFilter"
          >
            <template v-slot:label>
              <div class="label__text">
                Актуальность
              </div>
            </template>
            <template v-slot:append>
              <div class="search__field_label" @click="closeFilter" style="cursor: pointer">
                <v-icon :size="$vuetify.display.width >= 769 ? 45 : 30" color="#3254B9" class="mr-n2">close</v-icon>
              </div>
            </template>
          </v-select>
        </div>
        <v-icon :size="$vuetify.display.width >= 769 ? 30 : 20" color="#3254B9" class="search_icon mr-2" @click="openFilter" v-else-if="!filter_panel && !search_panel && promo_selection === 1">$custom_filter</v-icon>
        <div v-if="search_panel && !filter_panel" class="search__field">
          <v-text-field
              v-model="search.value"
              @keydown.enter="clickSearch"
              class="search__field_input"
              ref="search-field-input"
              color="#3254B9"
              base-color="#313743"
              variant="outlined"
              placeholder="Введите текст и нажмите кнопку поиска"
          >
            <template v-slot:label>
              <div class="search__field_label">
                Поиск
              </div>
            </template>
            <template v-slot:append>
              <div class="search__field_label" @click="closeSearch" style="cursor: pointer">
                <v-icon :size="$vuetify.display.width >= 769 ? 45 : 30" color="#3254B9" class="mr-n2">close</v-icon>
              </div>
            </template>
            <template v-slot:append-inner>
              <v-icon size="20" class="search_icon" @click="clickSearch" v-if="$vuetify.display.mdAndDown">$custom_search</v-icon>
            </template>
          </v-text-field>
        </div>
        <v-icon :size="$vuetify.display.width >= 769 ? 30 : 20" class="search_icon" @click="openSearch" v-else-if="!filter_panel && !search_panel">$custom_search</v-icon>
      </v-row>
    </div>
    <v-chip-group
        v-if="$vuetify.display.width < 1280"
        v-model="promo_selection"
        class="chip__container"
        mandatory
        @click="changePromoType(promo_selection)"
    >
      <v-chip>НОВЫЕ</v-chip>
      <v-chip>МОИ</v-chip>
    </v-chip-group>
    <div
        class="promo__content"
    >
      <PromocodeBlock
          v-if="promocodes.length > 0 && !isLoading"
          :promocodes="promocodes"
      />
      <div v-else-if="promocodes.length === 0 && !isLoading">
        <NoData
            :icon="'confirmation_number'"
            :text="'Следите за обновлениями.<br/> Уникальные промокоды уже в пути!'"
        />
      </div>
      <div v-else>
        <v-row no-gutters justify="center" align="center" style="height: 25vh; min-height: 200px">
          <fulfilling-square-spinner
              :animation-duration="4000"
              :size="100"
              color="#34347C"
          />
        </v-row>
      </div>
      <div class="promo__next" v-if="promocodes.length > 0 && !isLoading && promocodes_next !== null && !isSubLoading">
        <v-btn color="#376FFE" height="55" width="212" class="promo__next_btn" :disabled="isLoading || isSubLoading" @click="loadNextItems()">
          ПОКАЗАТЬ ЕЩЁ
        </v-btn>
      </div>
      <div v-if="isSubLoading">
        <v-row no-gutters justify="center" align="center" style="height: 25vh; min-height: 200px">
          <fulfilling-square-spinner
              :animation-duration="4000"
              :size="100"
              color="#34347C"
          />
        </v-row>
      </div>
    </div>

  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import PromocodeBlock from "@/modules/templates/PromocodeBlock.vue"
import { mapActions, mapGetters } from "vuex"
import names from "@/modules/core/routers/names"
import { FulfillingSquareSpinner } from 'epic-spinners'
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin"
import pa_names from "@/modules/personal_account/routers/names"
import NoData from "@/modules/templates/NoData.vue"

export default defineComponent({
  name: "Promocodes",
  components: {
    NoData,
    PromocodeBlock,
    FulfillingSquareSpinner
  },
  mixins: [PaginatedDataMapperMixin],
  data () {
    return {
      promocodes: [],
      promocodes_next: null,
      isLoading: true,
      isSubLoading: false,
      filter_panel: false,
      search_panel: false,
      search: {
        parameter: 'search',
      },
      // pagination: {
      filters: {
        is_actual: true
      },
      // },
      selectors: {
        is_actual: [
          { text: "Актуальные", value: true },
          { text: "Не актуальные", value: false },
          { text: "Все", value: 'null' },
        ],
      },
      promo_selection: 0,
      promo_selection_before: 0,
      search_local_value: undefined
    }
  },
  computed: {
    names: () => names,
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      getUserStatus: 'auth/getUserStatus',
      items: 'personal_account/promocodes/getPromocodes',
      count: 'personal_account/promocodes/getPromocodesCount',
      isLoadingPromocodes: 'personal_account/promocodes/isLoadingPromocodes',
      getPromocodesNext: 'personal_account/promocodes/getPromocodesNext'
    }),
  },
  methods: {
    ...mapActions({
      loadPromocodes: 'personal_account/promocodes/loadPromocodes',
      userUsedPromocodes: 'personal_account/promocodes/userUsedPromocodes',
    }),
    addCover (items, cover = true) {
      for (let i = 0; i < items.length; i++) {
        this.promocodes.push({ ...items[i], cover: cover })
      }
      this.isLoading = false
      this.isSubLoading = false
    },
    loadData (url = undefined) {
      if (this.promo_selection === 1) {
        this.loadUserData(url)
      } else {
        this.loadPromocodes({
          url: url,
          urlAppend: (url) => {
            return this.addPageParameter(this.addSizeParameter(url))
          },
          finalizer: (data, url) => {
            this.setCurrentLoadUrl(url)
            this.promocodes_next = data.next
            this.addCover(data.results)
          },
          catcher: () => {}
        })
      }
    },
    loadUserData (url = undefined) {
      this.userUsedPromocodes({
        url: url,
        urlAppend: (url) => {
          if (this.filters.is_actual !== undefined) {
            return this.addGetParameter(this.addPageParameter(this.addSizeParameter(url)), "is_actual", this.filters.is_actual)
          } else {
            return this.addPageParameter(this.addSizeParameter(url))
          }
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url)
          this.promocodes_next = data.next
          this.addCover(data.results, false)
        },
        catcher: () => {}
      })
    },
    loadNextItems () {
      if (this.promocodes_next !== null) {
        this.isSubLoading = true
        const url = this.promocodes_next
        const startIndex = url.indexOf("page=") + 5 // Получаем индекс символа после "page="
        this.pagination.need_reload = true
        this.pagination.page = url.slice(startIndex)
      }
    },
    changePromoType (selection) {
      if (!this.isLoadingPromocodes) {
        if (this.promo_selection_before !== selection) {
          this.isLoading = true
          this.promocodes = []
          this.loadCurrentType(selection)
          this.promo_selection_before = selection
        }
      } else {
        this.promo_selection = this.promo_selection_before
      }
    },
    loadCurrentType (selection) {
      this.promocodes = []
      this.search_panel = false
      this.search.value = ''
      this.search_local_value = ''
      this.filter_panel = false
      this.filters.is_actual = true
      if (selection === 1) {
        this.pagination.need_reload = false
        this.pagination.page = 1
        this.$nextTick(() => {
          this.pagination.need_reload = false
          this.loadUserData()
        })
      } else {
        this.pagination.need_reload = false
        this.pagination.page = 1
        this.$nextTick(() => {
          this.pagination.need_reload = false
          this.loadData()
        })
      }
    },
    clickSearch () {
      if (this.search.value !== undefined && this.search_local_value !== this.search.value) {
        this.isLoading = true
        this.promocodes = []
        this.pagination.need_reload = true
        this.searchData()
        this.search_local_value = this.search.value
      }
    },
    openFilter () {
      this.filter_panel = true
      this.$nextTick(() => {
        this.$refs['filter-field-input'].focus()
      })
    },
    clickFilter () {
      if (this.filters.is_actual !== undefined) {
        this.promocodes = []
        this.pagination.filters.is_actual = this.filters.is_actual
        this.pagination.need_reload = true
        if (this.filter_panel) {
          this.$nextTick(() => {
            this.$refs['filter-field-input'].blur()
          })
        }
      }
    },
    closeFilter () {
      this.isLoading = true
      this.promocodes = []
      this.filter_panel = false
      this.filters.is_actual = true
      this.loadCurrentType(this.promo_selection)
    },
    openSearch () {
      this.search_panel = true
      this.$nextTick(() => {
        this.$refs['search-field-input'].focus()
      })
    },
    closeSearch () {
      this.isLoading = true
      this.promocodes = []
      this.search_panel = false
      this.search.value = ''
      this.loadCurrentType(this.promo_selection)
    }
  },
  created () {
    if (!this.isAuthenticated) {
      this.$router.push({ name: names.MAIN })
    } else {
      if (!this.getUserStatus.approve || this.getUserStatus.agreement) {
        this.$router.push({ name: pa_names.MAIN })
      } else {
        this.loadData()
      }
    }
  }
})
</script>

<style scoped lang="scss">
.promo__title {
  display: flex;
  justify-content: space-between;
}

.promo__title--text {
  padding: 0;
  margin-bottom: 30px;
  text-transform: uppercase;
  font-size: 20px;
  font-weight: 700;
  color: #34347C;
  text-align: left;

  &::before {
    margin-right: 28px;
    content: "";
    display: inline-block;
    width: 14px;
    height: 14px;
    background-color: #376FFE;
  }
}

.search__field {
  margin-top: -10px;
  display: flex;
  justify-content: flex-end;
  flex-wrap: nowrap;
  width: 500px;
}

.search__field_input {
  height: 50px;
}

.search__field_label {
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  text-align: center;
}

.search_icon {
  cursor: pointer;
}

.promo__content {
  text-align: center;
  border-radius: 5px;
  width: 100%;
  background-color: white;
}

.promo__next {
  padding: 50px 0;
}

.promo__next_btn {
  border-radius: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #FFFFFF;
}

.chip__container {
  margin-top: -10px;
  margin-left: 20px;
}

/* Переопределяет v-chip */
.v-chip--variant-plain, .v-chip--variant-outlined, .v-chip--variant-text, .v-chip--variant-tonal {
  color: #3254B9 !important;
  background-color: white;
  font-weight: 500;
  opacity: 1 !important;
  border: 1px solid #3254B9;
  letter-spacing: 0.05em;
}

.v-chip--selected {
  background-color: #3254B9;
  color: white !important;
}

.v-chip-group .v-chip.v-chip--selected:not(.v-chip--disabled) .v-chip__overlay {
  opacity: 0;
}

@media screen and (max-width: 1440px) {
  .search__field {
    width: 400px;
  }
}

@media screen and (max-width: 1279px) {
  .chip__container {
    width: 100%;
    margin: -30px 0 10px;
  }
}

@media screen and (max-width: 960px) {
  .promo__content {
    padding: 50px;
    position: relative;
  }

  .chip__container {
    width: 100%;
    margin: -20px 0 20px;
  }
}

@media screen and (max-width: 768px) {
  .promo__title {
    margin-top: 20px;
  }

  .promo__content {
    padding: 20px;
  }

  .promo__title--text {
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 17px;

    &::before {
      margin-right: 20px;
      width: 10px;
      height: 10px;
    }
  }

  .chip__container {
    width: 100%;
    margin: -10px 0 10px;
  }

  .search__field_input {
    height: 70px;
  }

  .search__field_label {
    font-size: 14px;
    line-height: 17px;
  }
}
</style>
